import type { PrintData } from './usePrintData.types';
import type { PrintQueriesHandlers } from './usePrintQueriesHandlers.types';

import * as browser from 'utils/browser';
import * as helpers from './usePrintQueries.helpers';
import * as uiLib from '@compliance.ai/web-components';
import * as errorUtils from 'utils/errors';

export const usePrintQueriesHandlers = ({
  localActions
}: {
  localActions: PrintData['localActions'];
}): PrintQueriesHandlers => {
  const handleDocumentsFetchSuccess: PrintQueriesHandlers['handleDocumentsFetchSuccess'] =
    async data => {
      try {
        if (!data) {
          return;
        }

        localActions.setIsPrinting(true);

        const windowReference = !browser.isIE() ? window.open() : null;
        return helpers.fetchPDF({ windowReference, document: data.documents[0] });
      } catch (e) {
        uiLib.showNotification({
          type: uiLib.ALERT_TYPES.ERROR,
          title: 'Error',
          message: `Document was not included because the PDF is unavailable.`
        });
        errorUtils.logError(e as Error);
      } finally {
        localActions.setIsPrinting(false);
      }
    };

  return {
    handleDocumentsFetchSuccess
  };
};
